import React from 'react'
import { Table } from 'react-bootstrap'
import ToggleBar from '../../commoncomponents/toggleBar'
import { utcToReportDate } from '../../../utils/dateConvert'
import { rounding } from '../../../utils/math'
import { downloadCSVFile } from '../../../api/apiClient'
import Location from '../../commoncomponents/location';
import ShowIButtonName from '../../commoncomponents/showIButtonName';
import { formatTemperatureReading, getValidTemperature, temperatureReadingClass } from '../../../utils/temperature';

function RawMessagesEvents(props) {
    let tempBEnabled = props.tempBEnabled;
    let tempAEnabled = props.tempAEnabled;
    let driverIDEnabled = props.driverIDEnabled;
    let doorSensorEnabled = props.doorSensorEnabled || (props.reportDetail || []).some((message) => message.doorSensor || message.DoorSensor);
    let assetId = props.assetId;
    let assetName = props.assetCustomerName;
    let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
    const formatDoorSensorStatus = (value) => value == 1 ? "Closed" : "Open";
  
    const data = (
        <Table responsive striped>
            <thead>
                <tr className="nowwrapTH">
                    <th>ID</th>
                    <th>Recieved</th>
                    <th>Created</th>
                    <th>Location</th>
                    <th>LogID</th>
                    <th>Speed</th>
                    <th>Odometer</th>
                    <th>Trip</th>
                    <th>Ignition</th>
                    <th>Duress</th>
                    <th>Fridge</th>
                    {tempAEnabled && <th>Temp A</th>}
                    {tempBEnabled && <th>Temp B</th>}
                    {driverIDEnabled && <th>Driver ID</th>}
                    {doorSensorEnabled && <th>Door</th>}
                </tr>
            </thead>
            <tbody>
                {props.reportDetail.map((message, index) => {
                    const item = message.rawMessage
                    return (

                        <tr key={index}>
                            <td>{item.id}</td>
                            <td>{utcToReportDate(item.received)}</td>
                            <td>{utcToReportDate(item.created)}</td>
                            <td>
                                <Location
                                    address={<span><em>A</em>{`${item.gPRMC.latitude},${item.gPRMC.longitude}`}</span>}
                                    lat={item.gPRMC.latitude}
                                    lng={item.gPRMC.longitude}
                                />
                            </td>
                            <td>{item.messageID}</td>
                            <td>{rounding(item.gPRMC.speed)}</td>
                            <td>{item.odometer}</td>
                            <td>{item.tripCount}</td>
                            <td>{item.iO3 == 0 ? "Engine Off" : "Engine On"}</td>

                            <td>{item.messageID == 59 ? "Y" : "N"}</td>
                            <td>{item.iO1 == 0 ? "Off" : "On"}</td>
                            {tempAEnabled && <td className={temperatureReadingClass(item.sensorAValue)}>{formatTemperatureReading(item.sensorAValue)}</td>}
                            {tempBEnabled && <td className={temperatureReadingClass(item.sensorBValue)}>{formatTemperatureReading(item.sensorBValue)}</td>}
                            {driverIDEnabled && <td>
                                {item.ibutton && 
                                    <ShowIButtonName
                                        ibuttonId={message.ibuttonId}
                                        serialno={message.serialno}
                                        iButtonName={message.iButtonName}
                                    />}
                                </td>}
                            {doorSensorEnabled && <td>{formatDoorSensorStatus(item.iO2)}</td>}
                        </tr>
                    )

                })}

            </tbody>
        </Table>
    )

    const handleDownloadExcel = () => {
        const csvData = props.reportDetail.map((message) => ({
            ...message.rawMessage,
            sensorAValue: getValidTemperature(message.rawMessage.sensorAValue),
            sensorBValue: getValidTemperature(message.rawMessage.sensorBValue),
            ibuttonId: message.ibuttonId,
            serialno: message.serialno,
            iButtonName: message.iButtonName,
            doorSensorStatus: formatDoorSensorStatus(message.rawMessage.iO2),
        }));
        downloadCSVFile(csvData, "RawMsgs", assetName, timeZone, assetId);
    }

    return (
        <ToggleBar caption="Raw Messages & Events" download={handleDownloadExcel} openTab="false" icon="fa-database" color="#8a6d3b" content={data} />
    )
}

export default RawMessagesEvents;
